<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Manage Tags</h4>
            <p class="category">Modify and Manage your Tags</p>
          </md-card-header>
          <md-card-content>
             <notifications></notifications>
              <div class="loader" v-if="alltags == null">
               <ring-loader :loading="true" color="orange" ></ring-loader>
            </div>
            <div id="tags">
              <div class="title">
                <h2></h2>
              </div>
               <div class="md-autocomplete" style="width:120px;display:inline-block;">
            <md-autocomplete
              class="search"
              v-model="tagfilter"
              :md-options="emptylist"
             
            >
              <label>Filter Tags...</label>
            </md-autocomplete>
            </div>  
            <md-button class="md-info" @click="toggleCollapse">{{lastUnfolded ? 'Collapse All' : 'Expand All'}}</md-button>
             
              <div class="row">
                 	<!--<vue-drag-tree :data='data' :allowDrag='allowDrag' :allowDrop='allowDrop' :defaultText='"New Node"' @current-node-clicked='curNodeClicked' @drag="dragHandler" @drag-enter="dragEnterHandler" @drag-leave="dragLeaveHandler" @drag-over="dragOverHandler" @drag-end="dragEndHandler" @drop="dropHandler" v-slot="slotProps">
                      <span :class="[slotProps.isClicked ? 'i-am-clicked' : 'i-am-not-clicked']"></span>
                      <span class='i-am-node-name'>{{slotProps.nodeName}} Edit22</span> EDIT
                  </vue-drag-tree>-->
                   <Tree :value="tagTree" >
                     <span slot-scope="{node, index, path, tree}" style="cursor:pointer;">
                      <b @click="tree.toggleFold(node, path)">
                        {{node.children.length == 0 ? ' ' : (node.$folded ? '+' : '-')}}
                      </b>
                      {{node.name}} <!--({{node.children.length}})  -->
                      <span class="tagAction">
                        <span  v-if="node.children.length == 0" @click="clickDelete(node)">
                        <md-icon name="delicon" class="md-icon md-small"  style="float: right; cursor: pointer;">cancel</md-icon>
                        </span>
                        <span @click="clickEdit(node)">
                        <md-icon name="editicon" class="md-icon md-xsmall"   style="float: right; cursor: pointer;">edit</md-icon>
                        </span>
                      </span>
                    </span>
                   </Tree>
              </div>
            </div>
          <div>
              <md-dialog-prompt
                :md-active.sync="showEdit"
                v-model="editTag"
                md-title="Edit Tag Name"
                @md-confirm="editComplete"
                md-confirm-text="Done"
                md-confirm-class="md-success" />
            </div>
            <div>
              <md-dialog :md-active.sync="showDelete" class="delete_tag_modal">
                <md-dialog-title>Delete Tag</md-dialog-title>
              <p style="margin:30px;">
               Deleting the tag will NOT delete any memries that reference this tag. However if this is the only tag assigned to a 
               memry then that memry will no longer be tagged.
               <br/>
               You may want to replace this tag with another tag on any memries that reference it.
               <br/>
               <md-field>
              <label>Tags</label>
               <div>
                <vue-tags-input
                  v-model="replacetag"
                  :tags="replacetags"
                  @tags-changed="newTags => replacetags = newTags"
                   :autocomplete-items="filteredItems"
                   :add-on-key="[13,9, ':', ';']"
                   :add-only-from-autocomplete=true
                   :max-tags=1

                 />
              </div>
            </md-field>
              </p>
                <md-dialog-actions>
                  <md-button  @click="showDelete = false">Cancel</md-button>
                  <md-button class="md-danger" @click="deleteComplete">Delete</md-button>
                </md-dialog-actions>
              </md-dialog>
              
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import VueTagsInput from '@johmun/vue-tags-input';
import { SimpleTable } from "@/components";
import ApiService from "@/services/api.service";
import UtilService from "@/services/util.service";
import _ from "lodash";
import {Tree,walkTreeData, // Base tree
  Fold, Check, // plugins
  foldAll, unfoldAll //utils
} from 'he-tree-vue'
import 'he-tree-vue/dist/he-tree-vue.css'; // base style
import { RingLoader } from '@saeris/vue-spinners'

export default {
  components: {
     Tree: Tree.mixPlugins([Fold]),
     VueTagsInput,
     RingLoader
  },
  data() {
    return {
      replacetags: [],
      replacetag: '',
       showtags: [],
      alltags: null,
      currtags: [],
      currtag: {},
      editTag: null,
      emptylist: [],
      tagfilter: null,
      errorString: null,
      showAnswer: false,
      showHint: false,
      sampleSize: 20,
      sampleOnly: false,
      lastUnfolded: true,
      showEdit: false,
      showDelete: false,
      tagTree: [],
      autocompleteItems: []
    };
  },
   watch: {
        tagfilter: function(val, oldVal) {
            if((val == null || val == '') && (oldVal != undefined && val != oldVal))
              this.search(true);
              
            if(val.length > 2)
              this.search();
        }
    },
    computed: {
       filteredItems() {
          if(!this.replacetag || this.replacetag == null)
              return [];

          var editPath = this.currtag.path;
          return this.autocompleteItems.filter(i => {
            return i.text.toLowerCase().indexOf(this.replacetag.toLowerCase()) !== -1 && i.text != editPath;
          });
      }
    },
  mounted() {
        ApiService.getTags()
        .then(response => { 
           
           
            if(!response || response.data == null) {
              this.alltags = [];
            } else {
              this.alltags = response.data;
               console.log("Fetching Tags", response.data);
            }

             this.autocompleteItems = this.alltags.map(a => {
                  return { text: a.path };
                });

            console.log('AutoComplete',this.autocompleteItems);
            this.buildTree();
            this.toggleCollapse();
            //this.getShowTags(-1);
        });
       
  },
  methods: {
   search(clearall) {

      const value = this.tagfilter;
      console.log('Filtering ',this.tagfilter);
      //dont want to start on pseudo root
      walkTreeData(this.tagTree,node => {
        //only filter the  top node

        this.$set(node, '$hidden',node.parentid == -1 && node.name.toLowerCase().indexOf(value.toLowerCase()) === -1);
      })
    },
    getShowTags(parentId) {

       this.currtags = _.filter(this.alltags,{parentid: parentId});
       this.showtags = this.currtags;
       this.buildTree();
      this.sampleOnly = false
      if(parentId == -1) {
          this.currtag = null;
         
      } else {
          this.currtag = _.find(this.alltags, {id: parentId});
          
      }

    },
    toggleCollapse() {
      if(this.lastUnfolded)
        foldAll(this.tagTree);
      else
        unfoldAll(this.tagTree);

      // this.notifyVue("Testing!",true)
      this.lastUnfolded = !this.lastUnfolded;
    },


    buildTree(parent) {

        if(!parent || parent == null) {
            parent = {name: 'Tags',id:-1};
            this.tagTree = [];
        }

        let children = _.filter(this.alltags,{parentid: parent.id});
        _.forEach(children,(child) => {
            this.buildTree(child);           
             if(parent.id == -1) {
                this.tagTree.push(child);
                //console.log('Tree',this.tagTree);
              }
          })

        parent.children = children;

              
       /* if(parent.id == -1) {
         this.tagTree.push(parent);
          console.log('Tree',this.tagTree);
        } */
        

    },
    clickDelete(node) {
        this.currtag = node;
        this.editTag = node.name;
        this.showDelete = true;
    },

    deleteComplete() { 
       
       let removeId = this.currtag.id;
        let path  = this.replacetags.length > 0 ? this.replacetags[0].text : null;
        let replaceTag = _.find(this.alltags,{'path':path});
        //update DB
          ApiService.deleteTag(this.currtag,replaceTag).then(response => { 
           

            _.remove(this.alltags,(tag) => {
                return tag.id == removeId;
            })
              
             this.buildTree()

            this.currtag = null;
            this.showDelete = false;
                
             this.notifyVue("Done! Your tag has been deleted and related memries updated!",true)

           }, (err) => {
               this.notifyVue("Failed trying to delete your tag. Try again!",false)
           console.error('Tag delete Failed',err);
     
        });

     
    },

     removeNode(array, id) {
      return array.some((o, i, a) => o.id === id
          ? a.splice(i, 1)
          : this.removeNode(o.children || [], id)
      );
    },

    clickEdit(node) {
        this.currtag = node;
        this.editTag = node.name;
        this.showEdit = true;
    },

    editComplete() {
        this.currtag.name = this.editTag;
        this.showEdit = false;

        //update DB
          ApiService.updateTag(this.currtag).then(response => { 
           
           
             let findTags = _.filter(this.alltags,{"id": this.currtag.id});
            if(findTags != null && findTags.length > 0) {
              findTags[0].name = this.editTag;
            }

             this.notifyVue("Done! Your tag has been updated!",true)

           }, (err) => {
               this.notifyVue("Failed trying to update your tag. Try again!",false)
           console.error('Tag update Failed',err);
     
        });

        

        
    },
    filterTags(clear,showall) {

         console.log('Filter');

         //limit the amount shown if showing all with no filter
          if(this.tagfilter == null || this.tagfilter == '' || clear == true) {
              this.showtags = showall ?  this.currtags : this.currtags.slice(1,this.sampleSize);
              this.tagfilter = '';
              this.sampleOnly = this.showtags.length != this.currtags.length;
          } else {
              if(this.tagfilter.length > 2) {
                this.showtags = _.filter(this.currtags, (tag) => {
                    return  tag.name.toLowerCase().includes(this.tagfilter.toLowerCase());
              })
              }
              this.sampleOnly = false;
          }
   
    },
     getShowTagsByPath(path) {

       this.currtag = _.find(this.alltags, {path: path});
       this.currtags = _.filter(this.alltags,{parentid: this.currtag.id});
       this.tagfilter = '';
       this.showtags = this.currtags;
       this.sampleOnly = false;
      
     
    },

     notifyVue(msg, success) {
      var color = success ? 'info' : 'warning';
      this.$notify({
        message: msg,
        icon: "add_alert",
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: color
      });
    }
  
  }
};
</script>
